import {createSlice} from "@reduxjs/toolkit";

const initialReportsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  hatcheryOwners:null,
  reportsSIPS:null,
  reportsSIPSTotalCount:0,
  hatcheryOwnersTotalCount:0,
  reportForEdit: undefined,
  lastError: null,
  filteredBookings:null,
  filteredBookingsCount:0,
  filteredInvoicesCount:0,
  filteredInvoices:null,
  reportsIME:null,
  reportsIMETotalCount:0,
  reportsSWR:null,
  reportsSWRTotalCount:0,

};
export const callTypes = {
  list: "list",
  action: "action"
};

export const reportsSlice = createSlice({
  name: "reportsData",
  initialState: initialReportsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getReportById
    reportFetched: (state, action) => {
      state.actionsLoading = false;
      state.reportForEdit = action.payload.reportForEdit;
      state.error = null;
    },
    // findReports
    hatcheryOwnersFetched: (state, action) => {
      const { hatcheryOwnersTotalCount, hatcheryOwners } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.hatcheryOwners = hatcheryOwners;
      state.hatcheryOwnersTotalCount = hatcheryOwnersTotalCount;
    },
    reportsSIPSFetched: (state, action) => {
      const { reportsSIPSTotalCount, reportsSIPS } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.reportsSIPS = reportsSIPS;
      state.reportsSIPSTotalCount = reportsSIPSTotalCount;
    },
    reportsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    reportsFetchedIME: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.reportsIME = entities;
      state.reportsIMETotalCount = totalCount;
    },

    reportsFetchedSWR: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.reportsSWR = entities;
      state.reportsSWRTotalCount = totalCount;
    },


    BookingsFilteredFetched: (state, action) => {
      console.log(action.payload,"action.payload")
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.filteredBookings = entities;
      state.filteredBookingsCount = totalCount;

    },

    InvoicesFilteredFetched: (state, action) => {
      console.log(action.payload,"action.payload invoice")
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.filteredInvoices = entities;
      state.filteredInvoicesCount = totalCount;

    },
    // createReport
    reportCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.report);
    },
    // updateReport
    reportUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.report.id) {
          return action.payload.report;
        }
        return entity;
      });
    },
    // deleteReport
    reportDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteReports
    reportsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // reportsUpdateState
    reportsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
